export enum ChipColor {
    Default = 'default',
    Active = 'active',
    Primary = 'primary',
    BorderTransparent = 'borderTransparent',
    Transparent = 'transparent',
    Carbon = 'carbon',
    Secondary = 'secondary',
    Shine = 'shine',
    Blur = 'blur',
    BlurDark = 'blurDark',
    Golden = 'golden',
}

export type ChipColorValue = `${ChipColor}`;

export enum ChipSize {
    Smaller = 'smaller',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export type ChipSizeValue = `${ChipSize}`;
